import { useTranslation } from 'react-i18next';
import { useOpenLiveChat } from '@hub/hooks';
import { useTheme } from '@mui/material';
import { Button, Stack, Typography } from '@monorepo/nova-ui';
import { useStore } from '../../helpers/use-store';

export const FailedSendingMail = ({ isLoading }: { isLoading: boolean }) => {
  const {
    dataStore: { userStore },
  } = useStore();

  const { t } = useTranslation(['mailConfirmationNova']);
  const openLiveChat = useOpenLiveChat({ flow: 'failed-sending-mail' });

  const theme = useTheme();

  return (
    <Stack textAlign="center" gap={5}>
      <Typography variant={'h3'} textAlign="center" mt={6}>
        {t('mailConfirmationNova:error_title')}
      </Typography>
      <Typography textAlign="center">
        {t('mailConfirmationNova:send_failed_explanation')}
      </Typography>
      <Typography
        bgcolor={theme.palette.background.contrast}
        variant={'h6'}
        borderRadius={24}
        color={theme.palette.secondaryInvert.main}
        padding={theme.spacing(1.5)}
      >
        {userStore.currentUser.email}
      </Typography>
      <Typography textAlign="center">
        {t('mailConfirmationNova:not_your_email_contact')}
      </Typography>
      <Stack direction={'row'} justifyContent={'center'}>
        <Button
          size={'lg'}
          variant={'outlined'}
          loading={isLoading}
          onClick={openLiveChat}
        >
          {t('mailConfirmationNova:contact_support')}
        </Button>
      </Stack>
    </Stack>
  );
};
